import Reveal from "./Reveal";
import UserOrbit from "./visuals/UserOrbit";

const UserAtCenter = () => {
  return (
    <section id="integrations" className="scroll-mt-24 bg-background py-section relative overflow-hidden">
      <div className="container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-6 lg:order-1">
            <UserOrbit />
          </Reveal>

          <Reveal className="lg:col-span-6 lg:order-2" delay={0.15}>
            <p className="eyebrow">Integrations</p>
            <h2 className="display mt-5 text-section-title text-foreground">
              Connects to the systems your teams{" "}
              <span className="italic font-normal text-primary/95">already use.</span>
            </h2>
            <div className="mt-6 space-y-4 text-base md:text-lg text-foreground/75 leading-relaxed">
              <p>
                deepc connects to the clinical, operational, data, and AI systems
                already running across the health system — from EHR and imaging to
                worklists, reporting, BI, claims, in-house models, and agents.
              </p>
              <p>
                Standards like DICOM, HL7, and FHIR sit underneath, so AI workflows
                can run inside existing clinical and operational environments.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default UserAtCenter;
